import React from 'react';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { Theme } from '@app/theme';
import { Button, LockFeatureChip } from '@app/core';
import Seats from '@app/illu/Image/Seats.svg';
import { Feature } from '@app/api';
import { EmptyScreen, useFeatureRequiredCallback } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  buttonsDisplay: {
    display: 'flex',
    justifyContent: 'center',
    marginRight: -theme.marginBase * 2,
    [theme.media.mobile]: {
      flexDirection: 'column',
      marginRight: 0,
    },
  },
  button: {
    marginRight: theme.marginBase * 2,
    [theme.media.mobile]: {
      marginBottom: theme.marginBase * 2,
      marginRight: 0,
    },
  },
  chip: {
    marginRight: theme.marginBase,
  },
}));

interface Props {
  openPanelSubFormModal: () => void;
  openImportCsvModal: () => void;
  openCreation: () => void;
}

export const EmptyPanel = (props: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const openPanelSubFormModal = useFeatureRequiredCallback(
    Feature.PANEL_SUBSCRIPTION_FORM,
    props.openPanelSubFormModal,
  );
  const openImportCsvModal = useFeatureRequiredCallback(
    Feature.CSV_IMPORT,
    props.openImportCsvModal,
  );

  return (
    <EmptyScreen
      title={t('participants.list.empty.title')}
      text={t('participants.list.empty.text')}
      illustration={Seats}
      button={
        <div className={classes.buttonsDisplay}>
          <Button
            variant="muted"
            onClick={openPanelSubFormModal}
            className={classes.button}
          >
            <LockFeatureChip
              feature={Feature.PANEL_SUBSCRIPTION_FORM}
              className={classes.chip}
            />
            {t('participants.list.empty.buttonInvite')}
          </Button>
          <Button
            onClick={openImportCsvModal}
            variant="muted"
            className={classes.button}
          >
            <LockFeatureChip
              feature={Feature.CSV_IMPORT}
              className={classes.chip}
            />
            {t('participants.list.empty.buttonImport')}
          </Button>
          <Button onClick={props.openCreation} className={classes.button}>
            {t('participants.list.empty.button')}
          </Button>
        </div>
      }
    />
  );
};
